import React from 'react';

const NoteMessage = ({ children }) => (
  <div className="comparisons-debug-info -with-margin-below">{ children }</div>
);

export default NoteMessage;
